module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-popup"
  }, [_c('div', {
    staticClass: "page-popup-wrapper"
  }, [_c('mt-button', {
    ref: "button",
    attrs: {
      "size": "large",
      "type": "default",
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.popupVisible1 = true
      }
    }
  }, [_vm._v("中部弹出 popup")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "primary",
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.popupVisible2 = true
      }
    }
  }, [_vm._v("上侧弹出 popup")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "warning",
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.popupVisible3 = true
      }
    }
  }, [_vm._v("右侧弹出 popup")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large",
      "type": "danger",
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.popupVisible4 = true
      }
    }
  }, [_vm._v("下侧弹出 popup")])], 1), _vm._v(" "), _c('mt-popup', {
    staticClass: "mint-popup-1",
    style: ({
      top: _vm.buttonBottom + 10 + 'px'
    }),
    attrs: {
      "popup-transition": "popup-fade"
    },
    on: {
      "maskCallback": _vm.cancel
    },
    model: {
      value: (_vm.popupVisible1),
      callback: function($$v) {
        _vm.popupVisible1 = $$v
      },
      expression: "popupVisible1"
    }
  }, [_c('h1', [_vm._v("popup")]), _vm._v(" "), _c('p', [_vm._v("/ ˈpɑpˌʌp /")]), _vm._v(" "), _c('p', [_vm._v("n. 弹出式; [棒]内野飞球; 自动起跳式装置")]), _vm._v(" "), _c('p', [_vm._v("adj. 弹起的; 有自动起跳装置的")])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "mint-popup-2",
    attrs: {
      "position": "top",
      "modal": false
    },
    model: {
      value: (_vm.popupVisible2),
      callback: function($$v) {
        _vm.popupVisible2 = $$v
      },
      expression: "popupVisible2"
    }
  }, [_c('p', [_vm._v("更新成功")])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "mint-popup-3",
    attrs: {
      "position": "right",
      "modal": false
    },
    model: {
      value: (_vm.popupVisible3),
      callback: function($$v) {
        _vm.popupVisible3 = $$v
      },
      expression: "popupVisible3"
    }
  }, [_c('mt-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.popupVisible3 = false
      }
    }
  }, [_vm._v("关闭 popup")])], 1), _vm._v(" "), _c('mt-popup', {
    staticClass: "mint-popup-4",
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.popupVisible4),
      callback: function($$v) {
        _vm.popupVisible4 = $$v
      },
      expression: "popupVisible4"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "244px",
      "background-color": "#e8e8e8"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "12px 20px",
      "background-color": "#fff",
      "font-size": "17px"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("申请陈述：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "#06c1ae"
    },
    on: {
      "click": function($event) {
        _vm.popupVisible4 = false
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "display": "table",
      "margin-bottom": "5px"
    }
  })]), _vm._v(" "), _c('mt-cell-group', {
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_c('mt-textarea', {
    attrs: {
      "maxlength": "100",
      "rows": "4",
      "placeholder": "请输入"
    }
  })], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.popupVisible4 = false
      }
    }
  }, [_vm._v("取消")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbd175ae","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/popup.vue
// module id = 582
// module chunks = 0